import * as React from 'react';
import { translate } from 'react-i18next';

import Control from 'react-leaflet-control';
import { ButtonWithPopover, ButtonTypes } from 'common/components/core/button';
import {
    PopoverPlaceEnum,
    PopoverTriggerEnum
} from 'common/components/core/popover/popOverFactory';
import theme from './LeafletPM.scss';
import { dashboardColors } from 'common/enums/ColorEnum';

const DrawingOptionsEnum = {
    Polygon: 'Polygon',
    Polyline: 'Line',
    Circle: 'Circle',
    Cut: 'Cut'
};
class LeafletPMControl extends React.PureComponent {
    static defaultProps = {
        snappable: true,
        finishOn: 'dblclick'
    };

    state = {
        currentMode: null
    };

    componentDidMount() {
        const { map } = this.props;
        map && map.pm && map.on('pm:drawend', this.disableMode);
        map && map.pm && map.on('pm:cut', this.disableMode);
        document.addEventListener('keydown', this.handleKeyDown);
    }

    componentDidUpdate(prevProps) {
        const { map, error } = this.props;
        const { currentMode } = this.state;
        const { error: prevError } = prevProps;

        if (currentMode === DrawingOptionsEnum.Polygon && !prevError && error) {
            map.pm.Draw.Polygon._hintline.setStyle({
                color: dashboardColors.salmonTwo.code
            });
        }

        if (prevError && !error) {
            map.pm.Draw.Polygon._hintline.setStyle({
                color: dashboardColors.darkSkyBlue.code
            });
        }
    }

    componentWillUnmount() {
        document.removeEventListener('keydown', this.handleKeyDown);
    }

    disableMode = e => {
        this.setState(prevState => {
            if (e.shape === prevState.currentMode) {
                return { currentMode: null };
            }
        });
    };

    //Hack added to cancel drawing on escape and pan map with keyboard while editing.
    //https://github.com/codeofsumit/leaflet.pm/issues/136#issuecomment-396079874
    handleKeyDown = e => {
        const { currentMode } = this.state;
        const { map, onEscape } = this.props;
        if (!currentMode) {
            return;
        }

        if (e.keyCode === 27) {
            onEscape && onEscape(currentMode);
        } else {
            map && map.keyboard._onKeyDown(e);
        }
    };

    handleButtonClick = fieldId => {
        const { map, snappable, finishOn } = this.props;
        if (!map || !map.pm) {
            return;
        }

        const options = {
            snappable,
            finishOn,
            hintlineStyle: {
                color: dashboardColors.darkSkyBlue.code,
                dashArray: [5, 5]
            }
        };
        this.setState(prevState => {
            if (fieldId === prevState.currentMode) {
                return { currentMode: null };
            }
            return { currentMode: fieldId };
        });
        switch (fieldId) {
            case DrawingOptionsEnum.Polygon: {
                map.pm.Draw[DrawingOptionsEnum.Polygon].toggle(options);
                break;
            }
            case DrawingOptionsEnum.Polyline: {
                map.pm.Draw[DrawingOptionsEnum.Polyline].toggle(options);
                break;
            }
            case DrawingOptionsEnum.Circle: {
                map.pm.Draw[DrawingOptionsEnum.Circle].toggle(options);
                break;
            }
            case DrawingOptionsEnum.Cut: {
                map.pm.Draw[DrawingOptionsEnum.Cut].toggle({ snappable });
                break;
            }
        }
    };

    render() {
        const { position, t } = this.props;
        const { currentMode } = this.state;
        return (
            <Control position={position}>
                <div className={theme.drawingControls}>
                    <ButtonWithPopover
                        theme={theme}
                        className={theme.controlBtn}
                        icon="polygon"
                        buttonType={ButtonTypes.Icon}
                        onClick={this.handleButtonClick}
                        fieldId={DrawingOptionsEnum.Polygon}
                        isButtonSelected={
                            DrawingOptionsEnum.Polygon === currentMode
                        }
                        popOverContent={t('zoneMap.drawPolygon')}
                        place={PopoverPlaceEnum.Below}
                        triggerPopoverOn={PopoverTriggerEnum.Hover}
                        invertPopover
                    />
                    <ButtonWithPopover
                        theme={theme}
                        className={theme.controlBtn}
                        icon="draw-circle"
                        buttonType={ButtonTypes.Icon}
                        onClick={this.handleButtonClick}
                        fieldId={DrawingOptionsEnum.Circle}
                        isButtonSelected={
                            DrawingOptionsEnum.Circle === currentMode
                        }
                        popOverContent={t('zoneMap.drawCircle')}
                        place={PopoverPlaceEnum.Below}
                        triggerPopoverOn={PopoverTriggerEnum.Hover}
                        invertPopover
                    />
                    <ButtonWithPopover
                        theme={theme}
                        className={theme.controlBtn}
                        icon="polyline"
                        buttonType={ButtonTypes.Icon}
                        onClick={this.handleButtonClick}
                        fieldId={DrawingOptionsEnum.Polyline}
                        isButtonSelected={
                            DrawingOptionsEnum.Polyline === currentMode
                        }
                        popOverContent={t('zoneMap.drawLine')}
                        place={PopoverPlaceEnum.Below}
                        triggerPopoverOn={PopoverTriggerEnum.Hover}
                        invertPopover
                    />
                </div>
            </Control>
        );
    }
}

const LocalizedLeafletPMControl = translate('entityManagement')(
    LeafletPMControl
);
export { LocalizedLeafletPMControl as LeafletPMControl };
export default LocalizedLeafletPMControl;
